import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { Form, Button } from 'react-bootstrap'

const Search = () => {
  const [filter, setFilter] = useState("")
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if(filter !== "") {
      window.location = "filter/"+filter
    }
  }
  return (<>
    <Form onSubmit={(e) => handleSubmit(e)} className='search-form d-inline-flex h-100 p-2'>
      <Form.Group className="" controlId="formBasicEmail">
        <Form.Control type="text" placeholder="" onChange={e => setFilter(e.target.value)} className='search-form-text h-100px p-2 text-black-50 m-auto h-100'/>
      </Form.Group>
      <Link to={`/filter/${filter}`} className='bg-light border-0 text-black m-1'>
        <FontAwesomeIcon icon={faMagnifyingGlass} className="search-button h-t-turquoise p-1 text-black-50"/>
      </Link>
    </Form>
  </>

  )
}

export default Search